import { render } from "./AlphabetNavigation.vue?vue&type=template&id=0277a992&scoped=true"
import script from "./AlphabetNavigation.vue?vue&type=script&lang=js"
export * from "./AlphabetNavigation.vue?vue&type=script&lang=js"

import "./AlphabetNavigation.vue?vue&type=style&index=0&id=0277a992&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0277a992"]])

export default __exports__